import type { EffectParams } from '@swf/core/store';

import { checkAuth } from './utils';

const toggleFavoriteGame = async (
  payload: { gameTypeId: number; gameVariantId: number; action: 'Add' | 'Remove' },
  { actions, dispatch, rootState, request }: EffectParams
) => {
  try {
    const { gameTypeId, gameVariantId, action } = payload;
    const authSubject = checkAuth({ dispatch, rootState, actions });
    if (authSubject) {
      authSubject.subscribe(() => dispatch.casino.toggleFavoriteGame(payload));
    } else {
      request({
        service: 'casino.player.favorite.update',
        body: { gameTypeId, gameVariantId, action }
      });
    }
  } catch (error) {
    dispatch.modal.enqueue({
      path: '/casino/error',
      locationState: { error }
    });
  }
};

export default toggleFavoriteGame;
